import { AfterViewInit, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-bulkproduct',
  templateUrl: './bulkproduct.component.html',
  styleUrls: ['./bulkproduct.component.css']
})
export class BulkproductComponent implements OnInit, AfterViewInit, OnDestroy {


  productColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Product";

  filterby: string = "ACTIVE";



  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Sku', field: 'skucode' },
    { headerName: 'Product', field: 'productname' },
    { headerName: 'Category', field: 'categoryname' },
    { headerName: 'Subcategory', field: 'subcategoryname' },
    { headerName: 'Uom', field: 'uomname' },
    { headerName: 'Uomqty', field: 'uomqty' },
    { headerName: 'Price', field: 'price' },

  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex: 1,
  };



  constructor(private appService: DhukanDataService, public router: Router,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private productFindService: NgbModal, private loginService: LoginDataService) { this.fnServiceChanges(); }

  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }


  ngOnInit() {
    try {



      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetProduct();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {

  }

  ngOnDestroy(): void {

  }

  fngetProduct() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'productid': 0,
      'restaurantid': this.loginService.fnGetModRestaruntId(),
      'categoryid':0,
      'filterby': this.filterby
    }
    this.appService.getProductListview(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.productColl = res.json().result;
            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fnSetProduct() {
    var data = {
      'productColl': this.productColl
    }
    this.appService.fnSetProductBulk(data).subscribe(
      (res) => {
        console.log(res.json())
        if (res.json().status === 200) {
          this.toastr.success('', "The Product has been updated successfully.");

          this.fngetProduct();
        }
      },
      (err) => {
        console.log(err)
        this.toastr.error('Error', err);
      });

  }

  fnAddProduct() {
    try {
      this.router.navigate(['/AddProduct']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }

  fnEditProduct(deptid, actiontype) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'id': deptid,
          'actiontype': actiontype,
        }
      }

      this.router.navigate(['/AddProduct'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  public fnDeleteConfirm(deptid) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Product?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteProduct(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteProduct(deptid) {
    var data = {
      'productid': deptid,
    }
    this.appService.fnDeleteProduct(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The Product has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetProduct();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Grid



  fnActionEditClick(data) {

    if (!this.isedit) {
      return;
    }

    this.fnEditProduct(data.productid, data.actiontype);

  }

  fnActionDeleteClick(data) {
    if (!this.isdelete) {
      return;
    }

    this.fnDeleteConfirm(data.productid);


  }

  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'productgrouplist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
    // this.gridApi.exportDataAsCsv(params);
  }



  private fnSetDataTable() {

  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnGetDescription(id) {
    const index = this.productColl.findIndex(sku => sku.productid === id);

    if (index) {
      return this.productColl[index].productname;
    }
    else {
      return "";
    }

  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
